import {
  MotifFormField,
  MotifIcon,
  MotifOption,
  MotifSelect,
} from "@ey-xd/motif-react";
import "./CustomPagination.scss";
import { IconoirNavArrowLeft, IconoirNavArrowRight } from "@ey-xd/motif-icon";
import { useTranslation } from "react-i18next";
type CustomPaginationProps = {
  currentpage: number;
  pageSize: number;
  onChangePageSize: (page: number) => void;
  disableNext: boolean;
  pageSizeSelector: number[];
  allPageSize?: number;
  onChangeNextPage?: () => void;
  onChangePreviousPage?: () => void;
  apiData?: any;
  apiStatus?:
    | "rejected"
    | "pending"
    | "fulfilled"
    | "uninitialized"
    | undefined;
};

export default function CustomPagination({
  currentpage,
  pageSize,
  onChangePageSize,
  disableNext,
  pageSizeSelector,
  allPageSize,
  onChangeNextPage,
  onChangePreviousPage,
  apiData,
  apiStatus,
}: CustomPaginationProps) {
  let { t } = useTranslation();
  const currentPageNumber = currentpage;
  const totalRecords = apiData?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  let pageStart = pageSize * (currentPageNumber - 1) + 1;
  let pageEnd = pageSize * currentPageNumber;
  pageEnd = pageEnd > totalRecords ? totalRecords : pageEnd;
  if (totalPages === 0) {
    pageStart = 0;
    currentpage = 0;
  }

  return (
    <div className="pagination-row pad-t-10">
      <div className="left-row"></div>
      <div className="paginationPanel">
        <div className="select-label ">
          {`${t("pages.pagination.pageSize")}:`}
        </div>
        <MotifFormField>
          <MotifSelect
            ariaLabelledBy="select-label"
            onChange={onChangePageSize}
            placeholder=""
            value={String(pageSize)}
            triggerButtonProps={{ type: "button" }}
          >
            {pageSizeSelector.map((size) => (
              <MotifOption key={String(size)} value={String(size)}>
                {size === allPageSize ? t("pages.pagination.all") : String(size)}
              </MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>
        <div className="select-records-con">
          <span className="recordsstatusCon">{pageStart}</span> to{" "}
          <span className="recordsstatusCon">
            {pageEnd} / {totalRecords}
          </span>
        </div>

        <nav
          aria-label="Pagination Navigation"
          role="navigation"
          className="motif-pagination"
          data-motif-pagination="true"
        >
          <ul className="motif-pagination-list">
            <li className="motif-pagination-item"></li>
            {currentpage > 1 ? (
              <li className="motif-pagination-item">
                <button
                  title="Go to previous page"
                  type="button"
                  className="motif-icon-button motif-icon-button-small"
                  disabled={currentpage === 1 ? true : false}
                  data-motif-icon-button="true"
                  onClick={onChangePreviousPage}
                >
                  <span className="motif-icon" title="" data-motif-icon="true">
                    <MotifIcon
                      iconFunction={IconoirNavArrowLeft}
                      title="Left"
                      size="24"
                    />
                  </span>
                </button>
              </li>
            ):<>&nbsp;&nbsp;</>}
            <li className="motif-pagination-item current-page  ">
              {currentpage} / {totalPages}
            </li>
            {!disableNext && (
              <li className="motif-pagination-item">
                <button
                  title="Go to next page"
                  type="button"
                  className="motif-icon-button motif-icon-button-small"
                  disabled={
                    disableNext || ["pending"].includes(apiStatus || "")
                  }
                  data-motif-icon-button="true"
                  onClick={onChangeNextPage}
                >
                  <span className="motif-icon" title="" data-motif-icon="true">
                    <MotifIcon
                      iconFunction={IconoirNavArrowRight}
                      title="Right"
                      size="24"
                    />
                  </span>
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
}
